import { httpJson } from "./client";

export async function listInspectionEntries({ jobId = "", limit = 300, offset = 0 } = {}) {
  const params = new URLSearchParams();
  if (String(jobId || "").trim()) params.set("job_id", String(jobId || "").trim());
  params.set("limit", String(limit));
  params.set("offset", String(offset));
  return await httpJson(`/inspections?${params.toString()}`, { method: "GET" });
}

export async function createInspectionEntry(payload) {
  return await httpJson("/inspections", {
    method: "POST",
    body: payload,
  });
}

export async function deleteInspectionEntry(inspectionId) {
  const id = String(inspectionId || "").trim();
  if (!id) throw new Error("inspectionId is required");
  return await httpJson(`/inspections/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
}

